import { render, staticRenderFns } from "./ReportE.vue?vue&type=template&id=70ac50fa&scoped=true&"
import script from "./ReportE.vue?vue&type=script&lang=js&"
export * from "./ReportE.vue?vue&type=script&lang=js&"
import style0 from "./ReportE.vue?vue&type=style&index=0&id=70ac50fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac50fa",
  null
  
)

export default component.exports